import React from 'react';

import { ReactComponent as IconInstagram } from "../assets/instagram.svg";
import { ReactComponent as IconYoutube } from "../assets/youtube.svg";
import { ReactComponent as IconLinktree } from "../assets/linktree.svg";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer">
      <div className="footer-top bodycopy">
        <div className="footer-left">
          <a href="/" className="h1 focus:outline-none focus:ring-2 focus:ring-blue-600" style={{textDecoration: 'none', color: 'var(--text-primary)'}}>
            Erik Schott
          </a>
        </div>
        <div className="footer-center">
          <div className="social-media-buttons">
            <a href="https://www.youtube.com/@Erik_Schott" target="_blank" rel="noopener noreferrer" 
              title="Abonniere Erik auf YouTube in einem neuen Tab" aria-label="Besuche Erik's YouTube in einem neuen Tab">
              <IconYoutube width="24" height="24" />
            </a>
            <a href="https://linktr.ee/schottfilmproduction" target="_blank" rel="noopener noreferrer" 
              title="Besuche Erik's Linktree in einem neuen Tab" aria-label="Besuche Erik's Linktree in einem neuen Tab">
              <IconLinktree width="24" height="24" />
            </a>
            <a href="https://www.instagram.com/schott_film_production" target="_blank" rel="noopener noreferrer"
              title="Folge Erik auf Instagram in einem neuen Tab" aria-label="Besuche Erik's Instagram in einem neuen Tab">
              <IconInstagram width="24" height="24" />
            </a>
          </div>
        </div>
        <div className="footer-right" role="contentinfo">
          <p><a href="/impressum" title="Impressum" aria-label="Zur Impressumsseite">Impressum</a></p>
          <p><a href="/datenschutz" title="Datenschutzerklärung" aria-label="Zur Datenschutzerklärung">Datenschutz</a></p>
        </div>
      </div>
      <div className="footer-bottom bodycopy">
        <p>© {currentYear} Erik Schott. All rights reserved.</p>
      </div>
    </div>
  );
}